import React from "react";
import { useTranslation } from "react-i18next";

import { LegendGradientItemStyle, legendStyle } from "../style";
import { qgis_map_export_58_colors } from "../../util/colors";

export const InlandFloodHowden58Legend = () => {
  const { t } = useTranslation();

  const levelsStr = [55, 45, 35, 25, 15, 5].map((n) => `${n}`);

  return (
    <div style={legendStyle}>
      <div>
        <b>{`${t("riskAssessment.inlandFloodHowden58")}`}</b>
      </div>

      <LegendGradientItemStyle
        colors={qgis_map_export_58_colors}
        labels={levelsStr}
      ></LegendGradientItemStyle>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.inlandFloodHowden58")}
        </span>
      </div>
    </div>
  );
};
